import { Service } from '@genial/services';
import { selectorFamily } from 'recoil';

import { addAuthorizationHeader } from '../../pages/BatchTicketInvestLink/Constants';

import {
  batchTicketInvestLinkScreenName,
  batchTicketInvestWhatsAppDefaultNumber,
} from './constants';

export const whiteLabelByBasketCustomerIdQuery = selectorFamily<
  string,
  { basketCustomerId: string; jwtToken?: string }
>({
  key: 'WhiteLabel/BatchTicketInvestLink',
  get: ({ basketCustomerId, jwtToken }) => {
    return async () => {
      try {
        const response = await Service.WhiteLabel.V1.getWhitelabelByBasketCustomerId(
          {
            basketCustomerId,
            screenName: batchTicketInvestLinkScreenName,
          },
          addAuthorizationHeader(jwtToken)
        );

        if (response?.data?.waPhoneNumber) {
          return response.data.waPhoneNumber;
        }

        throw new Error('Erro ao recuperar número do whatsapp.');
      } catch (error) {
        console.error(error);

        return batchTicketInvestWhatsAppDefaultNumber;
      }
    };
  },
});
